import { Theme } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import MuiDialogActions from '@mui/material/DialogActions';

export const DialogActions = withStyles((theme: Theme) => ({
  root: {
    padding: `0 ${theme.spacing(4.5)} ${theme.spacing(6)}`,
  },
}))(MuiDialogActions);
